/*
    规则
*/

//数据格式
export namespace FORMAT {
    export const NOT_NULL = /^.+$/;     //不为空
    export const MOBILE = /^\d{11}$/;   //手机号码
    export const PASSWORD = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d$@$!%*?&]{6,15}$/;     //密码
}

//测试规则
export interface Rule {
    name: string,
    format: RegExp | Function,
    message: string
}

//提交数据
interface Data {
    [name: string]: string | number
}

export default class Rules {

    //格式规则
    private _ruleMap: Rule[];

    constructor(rules: Rule[] = []) {
        this._ruleMap = rules;
    } 

    //加入规则
    public join(name: string, format: RegExp | Function, message: string): void {
        this._ruleMap.push({
            name, format, message
        });
    }

    //测试规则
    public test(data: Data, callback: (rule: Rule) => void): boolean {
        let isPass = true;
        for (let k in data) {
            for (let rule of this._ruleMap) {
                if (rule.name == k) {
                    if (rule.format instanceof RegExp && !rule.format.test(data[k].toString())) {
                        isPass = false;
                        callback(rule);
                        break;
                    }
                    if (rule.format instanceof Function && !rule.format(data[k])) {
                        isPass = false;
                        callback(rule);
                        break;
                    }
                }
            }
        }
        return isPass;
    }
}

export { Rules };